var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-DOWNLOAD"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DOWNLOAD",
    clipPath: "url(#clip-DOWNLOAD)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "DOWNLOAD-2",
    "data-name": "DOWNLOAD"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_11434",
    "data-name": "Rechteck 11434",
    width: 48,
    height: 48,
    fill: "transparent",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_484",
    "data-name": "Gruppe 484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_251",
    "data-name": "Pfad 251",
    d: "M23.882,32l5.727-9H25V6H23V23H18.155Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_252",
    "data-name": "Pfad 252",
    d: "M30,10v2h8V40H10V12h8V10H8V42H40V10Z",
    fill: "#FFFFFF"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Download_icon.6a5a4ccd1ed4c4f608d09b827766a8ae.svg";